(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-legacy"] && !Shopify.designMode) return;
  try {
    


  /*
    const toggleGiftProduct = document.getElementById("gift-toggle");

    toggleGiftProduct.addEventListener('click', (event) => {

        isProductGift = !isProductGift
        toggleGiftProduct.classList.toggle("on");
        document.getElementById("gift-form").classList.toggle("hidden");
        document.getElementById("product_type").value = String(isProductGift);
        console.log( String(isProductGift) );

    });

  */
  //delivery certificate

  /*
  const scheduleDeliveryBtn = document.getElementById("gift-delivery-schedule");
  const scheduleNowBtn = document.getElementById("gift-delivery-now");
  const deliveryDateInput = document.getElementById("gift-delivery-date");

  scheduleDeliveryBtn.addEventListener("click", (event) => {
    scheduleNowBtn.classList.toggle("active");
    scheduleDeliveryBtn.classList.toggle("active");
    deliveryDateInput.classList.toggle("hidden");
  })

  scheduleNowBtn.addEventListener("click", (event) => {
  })
  */

  /*
  flatpickr("#gift-delivery-date-set", {
    minDate: 'today',
    enableTime: true,            // Enables the time picker
    dateFormat: "Y-m-d H:i",     // Format saved to the input (e.g., 2026-07-22 14:30)
    altInput: true,              // Creates a user-friendly display input
    altFormat: "F j, Y h:i K",   // Human-readable format (e.g., July 22, 2026 02:30 PM)
    time_24hr: false,             // Uses AM/PM instead of 24-hour mode
    minTminTime: minTimeStr,
    minuteIncrement: 15, // Sets time steps to 15-minute intervals
    hourIncrement: 1     // Default is 1 hour step
  });
  */


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    

// console.log('prod.pg')

  //const isGiftProduct = document.getElementById('isGiftCheck');
  //isGiftProduct.click();

  // const queryString = window.location.search;
  // const urlParams = new URLSearchParams(queryString);
  // if (urlParams.has('is_gift')) {
  //   const isGiftProduct = document.getElementById('isGiftCheck');
  //   isGiftProduct.click();
  // }


  /*
    const toggleGiftProduct = document.getElementById("gift-toggle");

    toggleGiftProduct.addEventListener('click', (event) => {

        isProductGift = !isProductGift
        toggleGiftProduct.classList.toggle("on");
        document.getElementById("gift-form").classList.toggle("hidden");
        document.getElementById("product_type").value = String(isProductGift);
        console.log( String(isProductGift) );

    });

  */
  //delivery certificate

  /*
  const scheduleDeliveryBtn = document.getElementById("gift-delivery-schedule");
  const scheduleNowBtn = document.getElementById("gift-delivery-now");
  const deliveryDateInput = document.getElementById("gift-delivery-date");

  scheduleDeliveryBtn.addEventListener("click", (event) => {
    scheduleNowBtn.classList.toggle("active");
    scheduleDeliveryBtn.classList.toggle("active");
    deliveryDateInput.classList.toggle("hidden");
  })

  scheduleNowBtn.addEventListener("click", (event) => {
  })
  */

  /*
  flatpickr("#gift-delivery-date-set", {
    minDate: 'today',
    enableTime: true,            // Enables the time picker
    dateFormat: "Y-m-d H:i",     // Format saved to the input (e.g., 2026-07-22 14:30)
    altInput: true,              // Creates a user-friendly display input
    altFormat: "F j, Y h:i K",   // Human-readable format (e.g., July 22, 2026 02:30 PM)
    time_24hr: false,             // Uses AM/PM instead of 24-hour mode
    minTminTime: minTimeStr,
    minuteIncrement: 15, // Sets time steps to 15-minute intervals
    hourIncrement: 1     // Default is 1 hour step
  });
  */


  } catch(e) { console.error(e); }
})();
})();
